import { render, staticRenderFns } from "./TarjetaKpi.vue?vue&type=template&id=1e9c4d60&scoped=true&"
import script from "./TarjetaKpi.vue?vue&type=script&lang=js&"
export * from "./TarjetaKpi.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaKpi.vue?vue&type=style&index=0&id=1e9c4d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9c4d60",
  null
  
)

export default component.exports